import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';


export const ThirdPartyNotice = () => {

    const handleGoBack = () => {
        window.history.back(); 
    };

    // Create a JavaScript Date object to get the current date
    const currentDate = new Date();

    // Define a function to format the date as "dddd, dd MMMM yyyy"
    const formatDate = (date) => {
        const options = { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' };
        return date.toLocaleDateString(undefined, options);
    };

    return (
        <div>
            <Modal isOpen={true}  style={{ maxWidth: '1000px', width: '100%' }}>
                <ModalHeader toggle={handleGoBack} >
                    <span>SpheraCloud Third Party Component Notices</span>
                </ModalHeader>
                <ModalBody>
                    <div id="LayerRight" style={{ width: '100%' }}>
                        <div id="Content">
                            <h3>SpheraCloud Third Party Component Notices</h3>
                            <h4>{formatDate(currentDate)}</h4>
                            <h5>Overview</h5>
                            <h6>SpheraCloud uses Open Source Software components. Applicable disclosures and license terms are listed below.</h6>

                            <hr style={{ borderWidth: '5px' }} />

                            <h5>Azure.Core</h5>
                             <h6>v1.25.0</h6>

                            <p>
                                DESCRIPTION<br />
                                The implementation of the Azure Client Pipeline.
                            </p>
                            <p>
                                LICENSE<br />
                                MIT License<br />
                                <a href="https://licenses.nuget.org/MIT" target="_blank">https://licenses.nuget.org/MIT</a><br />
                            </p>
                            <hr style={{ borderWidth: '3px' }} />

                            <h5>Azure.Storage.Blobs</h5>
                            <h6>v12.14.1</h6>

                            <p>
                                DESCRIPTION<br />
                                This client library enables working with the Microsoft Azure Storage Blob service for storing binary and text data.
                            </p>
                            <p>
                                LICENSE<br />
                                MIT License<br />
                                <a href="https://licenses.nuget.org/MIT" target="_blank">https://licenses.nuget.org/MIT</a><br />
                            </p>
                            <hr style={{ borderWidth: '3px' }} />

                            <h5>Azure.Storage.Common</h5>
                            <h6>v12.13.0</h6>

                            <p>
                                DESCRIPTION<br />
                                This client library enables working with the Microsoft Azure Storage services which include the blob and file services for storing binary and text data, and the queue service for storing messages that may be accessed by a client.
                            </p>
                            <p>
                                LICENSE<br />
                                MIT License<br />
                                <a href="https://licenses.nuget.org/MIT" target="_blank">https://licenses.nuget.org/MIT</a><br />
                            </p>
                            <hr style={{ borderWidth: '3px' }} />

                            <h5>Azure.Storage.Common</h5>
                            <h6>v12.13.0</h6>

                            <p>
                                DESCRIPTION<br />
                                This client library enables working with the Microsoft Azure Storage services which include the blob and file services for storing binary and text data, and the queue service for storing messages that may be accessed by a client.
                            </p>
                            <p>
                                LICENSE<br />
                                MIT License<br />
                                <a href="https://licenses.nuget.org/MIT" target="_blank">https://licenses.nuget.org/MIT</a><br />
                            </p>
                            <hr style={{ borderWidth: '3px' }} />

                            <h5>Azure.Storage.Files.Shares</h5>
                            <h6>v12.12.1</h6>

                            <p>
                                DESCRIPTION<br />
                                This client library enables working with the Microsoft Azure Storage File Shares service for storing binary and text data.
                            </p>
                            <p>
                                LICENSE<br />
                                MIT License<br />
                                <a href="https://licenses.nuget.org/MIT" target="_blank">https://licenses.nuget.org/MIT</a><br />
                            </p>
                            <hr style={{ borderWidth: '3px' }} />

                            <h5>Microsoft.AspNetCore.Authentication.OpenIdConnect</h5>
                            <h6>v6.0.14</h6>

                            <p>
                                DESCRIPTION<br />
                                ASP.NET Core middleware that enables an application to support the OpenID Connect authentication workflow.
                            </p>
                            <p>
                                LICENSE<br />
                                MIT License<br />
                                <a href="https://licenses.nuget.org/MIT" target="_blank">https://licenses.nuget.org/MIT</a><br />
                            </p>
                            <hr style={{ borderWidth: '3px' }} />

                            <h5>Microsoft.AspNetCore.Mvc.Versioning</h5>
                            <h6>v5.0.0</h6>

                            <p>
                                DESCRIPTION<br />
                                A service API versioning library for Microsoft ASP.NET Core.
                            </p>
                            <p>
                                LICENSE<br />
                                MIT License<br />
                                <a href="https://licenses.nuget.org/MIT" target="_blank">https://licenses.nuget.org/MIT</a><br />
                            </p>
                            <hr style={{ borderWidth: '3px' }} />

                            <h5>Microsoft.AspNetCore.Mvc.Versioning.ApiExplorer</h5>
                            <h6>v5.0.0</h6>

                            <p>
                                DESCRIPTION<br />
                                ASP.NET Core MVC API explorer functionality for discovering metadata such as the list of API-versioned controllers and actions, and their URLs and allowed HTTP methods.
                            </p>
                            <p>
                                LICENSE<br />
                                MIT License<br />
                                <a href="https://licenses.nuget.org/MIT" target="_blank">https://licenses.nuget.org/MIT</a><br />
                            </p>
                            <hr style={{ borderWidth: '3px' }} />

                            <h5>Microsoft.AspNetCore.SpaProxy</h5>
                            <h6>v6.0.10</h6>

                            <p>
                                DESCRIPTION<br />
                                Helpers for launching the SPA CLI proxy automatically when the application starts in ASP.NET MVC Core.
                            </p>
                            <p>
                                LICENSE<br />
                                MIT License<br />
                                <a href="https://licenses.nuget.org/MIT" target="_blank">https://licenses.nuget.org/MIT</a><br />
                            </p>
                            <hr style={{ borderWidth: '3px' }} />

                            <h5>Microsoft.EntityFrameworkCore.SqlServer</h5>
                            <h6>v7.0.2</h6>

                            <p>
                                DESCRIPTION<br />
                                Microsoft SQL Server database provider for Entity Framework Core.
                            </p>
                            <p>
                                LICENSE<br />
                                MIT License<br />
                                <a href="https://licenses.nuget.org/MIT" target="_blank">https://licenses.nuget.org/MIT</a><br />
                            </p>
                            <hr style={{ borderWidth: '3px' }} />

                            <h5>Microsoft.Identity.Web</h5>
                            <h6>v2.5.0</h6>

                            <p>
                                DESCRIPTION<br />
                                This package enables ASP.NET Core web apps and web APIs to use the Microsoft identity platform (formerly Azure AD v2.0).
                            </p>
                            <p>
                                LICENSE<br />
                                MIT License<br />
                                <a href="https://licenses.nuget.org/MIT" target="_blank">https://licenses.nuget.org/MIT</a><br />
                            </p>
                            <hr style={{ borderWidth: '3px' }} />

                            <h5>NLog.Extensions.AzureBlobStorage</h5>
                            <h6>v4.1.0</h6>

                            <p>
                                DESCRIPTION<br />
                                NLog BlobStorageTarget for writing to Azure Cloud Blob Storage.
                            </p>
                            <p>
                                LICENSE<br />
                                MIT License<br />
                                <a href="https://licenses.nuget.org/MIT" target="_blank">https://licenses.nuget.org/MIT</a><br />
                            </p>
                            <hr style={{ borderWidth: '3px' }} />

                            <h5>NSwag.Annotations</h5>
                            <h6>v13.19.0</h6>

                            <p>
                                DESCRIPTION<br />
                                The OpenAPI/Swagger API toolchain for .NET and TypeScript.
                            </p>
                            <p>
                                LICENSE<br />
                                MIT License<br />
                                <a href="https://licenses.nuget.org/MIT" target="_blank">https://licenses.nuget.org/MIT</a><br />
                            </p>
                            <hr style={{ borderWidth: '3px' }} />

                            <h5>Swashbuckle.AspNetCore</h5>
                            <h6>v6.2.3</h6>

                            <p>
                                DESCRIPTION<br />
                                Swagger tools for documenting APIs built on ASP.NET Core.
                            </p>
                            <p>
                                LICENSE<br />
                                MIT License<br />
                                <a href="https://licenses.nuget.org/MIT" target="_blank">https://licenses.nuget.org/MIT</a><br />
                            </p>
                            <hr style={{ borderWidth: '3px' }} />

                            <h5>System.Data.SqlClient</h5>
                            <h6>v4.8.5</h6>

                            <p>
                                DESCRIPTION<br />
                                Provides the data provider for SQL Server. These classes provide access to versions of SQL Server and encapsulate database-specific protocols, including tabular data stream (TDS).
                            </p>
                            <p>
                                LICENSE<br />
                                MIT License<br />
                                <a href="https://licenses.nuget.org/MIT" target="_blank">https://licenses.nuget.org/MIT</a><br />
                            </p>
                            <hr style={{ borderWidth: '3px' }} />

                            <h5>Swashbuckle.AspNetCore.Swagger</h5>
                            <h6>v6.2.3</h6>

                            <p>
                                DESCRIPTION<br />
                                Middleware to expose Swagger JSON endpoints from APIs built on ASP.NET Core.
                            </p>
                            <p>
                                LICENSE<br />
                                MIT License<br />
                                <a href="https://licenses.nuget.org/MIT" target="_blank">https://licenses.nuget.org/MIT</a><br />
                            </p>
                            <hr style={{ borderWidth: '3px' }} />

                            <h5>Swashbuckle.AspNetCore.SwaggerGen</h5>
                            <h6>v6.2.3</h6>

                            <p>
                                DESCRIPTION<br />
                                Swagger Generator for APIs built on ASP.NET Core.
                            </p>
                            <p>
                                LICENSE<br />
                                MIT License<br />
                                <a href="https://licenses.nuget.org/MIT" target="_blank">https://licenses.nuget.org/MIT</a><br />
                            </p>
                            <hr style={{ borderWidth: '3px' }} />

                            <h5>Swashbuckle.AspNetCore.SwaggerUI</h5>
                            <h6>v6.2.3</h6>

                            <p>
                                DESCRIPTION<br />
                                Middleware to expose an embedded version of the swagger-ui from an ASP.NET Core application.
                            </p>
                            <p>
                                LICENSE<br />
                                MIT License<br />
                                <a href="https://licenses.nuget.org/MIT" target="_blank">https://licenses.nuget.org/MIT</a><br />
                            </p>
                            <hr style={{ borderWidth: '3px' }} />

                            <h5>NETStandard.Library</h5>
                            <h6>v2.0.3</h6>

                            <p>
                                DESCRIPTION<br />
                                A set of standard .NET APIs that are prescribed to be used and supported together.
                            </p>
                            <p>
                                LICENSE<br />
                                MIT License<br />
                                <a href="https://licenses.nuget.org/MIT" target="_blank">https://licenses.nuget.org/MIT</a><br />
                            </p>
                            <hr style={{ borderWidth: '3px' }} />

                            <h5>coverlet.collector</h5>
                            <h6>v3.1.2</h6>

                            <p>
                                DESCRIPTION<br />
                                Coverlet is a cross platform code coverage library for .NET, with support for line, branch and method coverage.
                            </p>
                            <p>
                                LICENSE<br />
                                MIT License<br />
                                <a href="https://licenses.nuget.org/MIT" target="_blank">https://licenses.nuget.org/MIT</a><br />
                            </p>
                            <hr style={{ borderWidth: '3px' }} />

                            <h5>Microsoft.Extensions.Configuration</h5>
                            <h6>v6.0.1</h6>

                            <p>
                                DESCRIPTION<br />
                                Implementation of key-value pair based configuration for Microsoft.Extensions.Configuration. Includes the memory configuration provider.
                            </p>
                            <p>
                                LICENSE<br />
                                MIT License<br />
                                <a href="https://licenses.nuget.org/MIT" target="_blank">https://licenses.nuget.org/MIT</a><br />
                            </p>
                            <hr style={{ borderWidth: '3px' }} />

                            <h5>Microsoft.NET.Test.Sdk</h5>
                            <h6>v17.3.2</h6>

                            <p>
                                DESCRIPTION<br />
                                The MSbuild targets and properties for building .NET test projects.
                            </p>
                            <p>
                                LICENSE<br />
                                MIT License<br />
                                <a href="https://licenses.nuget.org/MIT" target="_blank">https://licenses.nuget.org/MIT</a><br />
                            </p>
                            <hr style={{ borderWidth: '3px' }} />

                            <h5>xunit.runner.visualstudio</h5>
                            <h6>v2.4.5</h6>

                            <p>
                                DESCRIPTION<br />
                                Visual Studio 2019 16.8+ Test Explorer runner for the xUnit.net framework.
                            </p>
                            <p>
                                LICENSE<br />
                                MIT License<br />
                                <a href="https://licenses.nuget.org/MIT" target="_blank">https://licenses.nuget.org/MIT</a><br />
                            </p>
                            <hr style={{ borderWidth: '3px' }} />

                            <h5>AspNetCore.HealthChecks.UI.Client</h5>
                            <h6>v7.0.0</h6>

                            <p>
                                DESCRIPTION<br />
                                HealthChecks.UI.Client contains some mandatory abstractions to work with HealthChecks.UI.
                            </p>
                            <p>
                                LICENSE<br />
                                Apache License<br />
                                Version 2.0, January 2004<br />
                                <a href="https://www.apache.org/licenses/" target="_blank">https://www.apache.org/licenses/</a><br />
                            </p>
                            <hr style={{ borderWidth: '3px' }} />

                            <h5>FluentValidation</h5>
                            <h6>v11.6.0</h6>

                            <p>
                                DESCRIPTION<br />
                                A validation library for .NET that uses a fluent interface to construct strongly-typed validation rules.
                            </p>
                            <p>
                                LICENSE<br />
                                Apache License<br />
                                Version 2.0, January 2004<br />
                                <a href="https://www.apache.org/licenses/" target="_blank">https://www.apache.org/licenses/</a><br />
                            </p>
                            <hr style={{ borderWidth: '3px' }} />

                            <h5>NEST</h5>
                            <h6>v7.17.5</h6>

                            <p>
                                DESCRIPTION<br />
                                Strongly typed interface to Elasticsearch. Fluent and classic object initializer mappings of requests and responses. Uses and exposes Elasticsearch.Net.
                            </p>
                            <p>
                                LICENSE<br />
                                Apache License<br />
                                Version 2.0, January 2004<br />
                                <a href="https://www.apache.org/licenses/" target="_blank">https://www.apache.org/licenses/</a><br />
                            </p>
                            <hr style={{ borderWidth: '3px' }} />

                            <h5>Newtonsoft.Json</h5>
                            <h6>v13.0.3</h6>

                            <p>
                                DESCRIPTION<br />
                                Json.NET is a popular high-performance JSON framework for .NET.
                            </p>
                            <p>
                                LICENSE<br />
                                Apache License<br />
                                Version 2.0, January 2004<br />
                                <a href="https://www.apache.org/licenses/" target="_blank">https://www.apache.org/licenses/</a><br />
                            </p>
                            <hr style={{ borderWidth: '3px' }} />

                            <h5>Sieve</h5>
                            <h6>v2.5.5</h6>

                            <p>
                                DESCRIPTION<br />
                                Sieve is a simple, clean, and extensible framework for .NET Core that adds sorting, filtering, and pagination functionality out of the box.
                                Most common use case would be for serving ASP.NET Core GET queries. Documentation available on GitHub: https://github.com/Biarity/Sieve/
                            </p>
                            <p>
                                LICENSE<br />
                                Apache License<br />
                                Version 2.0, January 2004<br />
                                <a href="https://www.apache.org/licenses/" target="_blank">https://www.apache.org/licenses/</a><br />
                            </p>
                            <hr style={{ borderWidth: '3px' }} />

                            <h5>Elasticsearch.Net</h5>
                            <h6>v7.17.5</h6>

                            <p>
                                DESCRIPTION<br />
                                Exposes all the Elasticsearch API endpoints but leaves you in control of building the request and response bodies. Comes with built in cluster failover/connection pooling support.
                            </p>
                            <p>
                                LICENSE<br />
                                Apache License<br />
                                Version 2.0, January 2004<br />
                                <a href="https://www.apache.org/licenses/" target="_blank">https://www.apache.org/licenses/</a><br />
                            </p>
                            <hr style={{ borderWidth: '3px' }} />

                            <h5>xunit</h5>
                            <h6>v2.4.2</h6>

                            <p>
                                DESCRIPTION<br />
                                xUnit.net is a developer testing framework, built to support Test Driven Development, with a design goal of extreme simplicity and alignment with framework features.
                            </p>
                            <p>
                                LICENSE<br />
                                Apache License<br />
                                Version 2.0, January 2004<br />
                                <a href="https://www.apache.org/licenses/" target="_blank">https://www.apache.org/licenses/</a><br />
                            </p>
                            <hr style={{ borderWidth: '3px' }} />

                            <h5>NLog</h5>
                            <h6>v5.1.3</h6>

                            <p>
                                DESCRIPTION<br />
                                NLog is a logging platform for .NET with rich log routing and management capabilities.NLog supports traditional logging, structured logging and the combination of both.
                            </p>
                            <p>
                                LICENSE<br />
                                BSD-3-Clause License<br />
                                <a href="https://licenses.nuget.org/BSD-3-Clause" target="_blank">https://licenses.nuget.org/BSD-3-Clause</a><br /><br />
                            </p>
                            <hr style={{ borderWidth: '3px' }} />

                            <h5>NLog.Web.AspNetCore</h5>
                            <h6>v5.2.3</h6>

                            <p>
                                DESCRIPTION<br />
                                Integrates NLog as provider for Microsoft.Extensions.Logging, and provides NLog LayoutRenderers to enrich logging output with details from HttpContext.
                            </p>
                            <p>
                                LICENSE<br />
                                BSD-3-Clause License<br />
                                <a href="https://licenses.nuget.org/BSD-3-Clause" target="_blank">https://licenses.nuget.org/BSD-3-Clause</a><br /><br />
                            </p>
                            <hr style={{ borderWidth: '3px' }} />

                            <h5>NLog.Extensions.Logging</h5>
                            <h6>v5.2.3</h6>

                            <p>
                                DESCRIPTION<br />
                                NLog LoggerProvider for Microsoft.Extensions.Logging for logging in .NET Standard libraries and .NET Core applications.
                            </p>
                            <p>
                                LICENSE<br />
                                BSD-2-Clause License<br />
                                <a href="https://licenses.nuget.org/BSD-2-Clause" target="_blank">https://licenses.nuget.org/BSD-2-Clause</a><br /><br />
                            </p>
                            <hr style={{ borderWidth: '3px' }} />

                            <h5>@azure/msal-browser</h5>
                            <h6>v2.31.0</h6>

                            <p>
                                DESCRIPTION<br />
                                Microsoft Authentication Library for JavaScript (MSAL.js) for Browser-Based Single-Page Applications.
                            </p>
                            <p>
                                LICENSE<br />
                                MIT License<br />
                                <a href="https://licenses.nuget.org/MIT" target="_blank">https://licenses.nuget.org/MIT</a><br />
                            </p>
                            <hr style={{ borderWidth: '3px' }} />

                            <h5>@azure/msal-react</h5>
                            <h6>v1.4.10</h6>

                            <p>
                                DESCRIPTION<br />
                                Microsoft Authentication Library for React.
                            </p>
                            <p>
                                LICENSE<br />
                                MIT License<br />
                                <a href="https://licenses.nuget.org/MIT" target="_blank">https://licenses.nuget.org/MIT</a><br />
                            </p>
                            <hr style={{ borderWidth: '3px' }} />

                            <h5>@babel/preset-env</h5>
                            <h6>v7.22.10</h6>

                            <p>
                                DESCRIPTION<br />
                                Smart preset that allows you to use the latest JavaScript without needing to micromanage which syntax transforms (and optionally, browser polyfills) are needed by your target environment(s).
                            </p>
                            <p>
                                LICENSE<br />
                                MIT License<br />
                                <a href="https://licenses.nuget.org/MIT" target="_blank">https://licenses.nuget.org/MIT</a><br />
                            </p>
                            <hr style={{ borderWidth: '3px' }} />

                            <h5>@babel/preset-react</h5>
                            <h6>v7.22.5</h6>

                            <p>
                                DESCRIPTION<br />
                                A preset in Babel is a collection of plugins that are used to support specific language features.
                            </p>
                            <p>
                                LICENSE<br />
                                MIT License<br />
                                <a href="https://licenses.nuget.org/MIT" target="_blank">https://licenses.nuget.org/MIT</a><br />
                            </p>
                            <hr style={{ borderWidth: '3px' }} />

                            <h5>@progress/kendo-licensing</h5>
                            <h6>v1.3.1</h6>
                            <h5>@progress/kendo-react-animation</h5>
                            <h6>v5.16.1</h6>
                            <h5>@progress/kendo-react-buttons</h5>
                            <h6>v5.16.1</h6>
                            <h5>@progress/kendo-react-common</h5>
                            <h6>v5.16.1</h6>
                            <h5>@progress/kendo-react-data-tools</h5>
                            <h6>v5.16.1</h6>
                            <h5>@progress/kendo-react-dateinputs</h5>
                            <h6>v5.16.1</h6>
                            <h5>@progress/kendo-react-dropdowns</h5>
                            <h6>v5.16.1</h6>
                            <h5>@progress/kendo-react-excel-export</h5>
                            <h6>v5.16.1</h6>
                            <h5>@progress/kendo-react-grid</h5>
                            <h6>v5.16.1</h6>
                            <h5>@progress/kendo-react-inputs</h5>
                            <h6>v5.16.1</h6>
                            <h5>@progress/kendo-react-intl</h5>
                            <h6>v5.16.1</h6>
                            <h5>@progress/kendo-react-treeview</h5>
                            <h6>v5.16.1</h6>
                            <h5>@progress/kendo-react-upload</h5>
                            <h6>v5.16.1</h6>
                            <h5>@progress/kendo-svg-icons</h5>
                            <h6>v1.8.0</h6>
                            <h5>@progress/kendo-theme-default</h5>
                            <h6>v5.8.1</h6>
                            <p>
                                DESCRIPTION<br />
                                These packages are part of the Kendo UI family of UI Component suites.
                            </p>
                            <p>
                                LICENSE<br />
                                Progress Kendo UI Licensing<br />
                                This is commercial software.
                                Copyright � 2022 Progress Software Corporation and/or its subsidiaries or affiliates.
                                All Rights Reserved.Progress, Telerik, and certain product names used herein are trademarks or registered trademarks of Progress Software Corporation and/or one of its subsidiaries or affiliates in the U.S. and/or other countries<br />
                            </p>
                            <hr style={{ borderWidth: '3px' }} />

                            <h5>@testing-library/jest-dom</h5>
                            <h6>v5.17.0</h6>
                            <h5>@testing-library/react</h5>
                            <h6>v14.0.0</h6>
                            <p>
                                DESCRIPTION<br />
                                Simple and complete React DOM testing utilities that encourage good testing practices.
                            </p>
                            <p>
                                LICENSE<br />
                                MIT License<br />
                                <a href="https://licenses.nuget.org/MIT" target="_blank">https://licenses.nuget.org/MIT</a><br />
                            </p>
                            <hr style={{ borderWidth: '3px' }} />

                            <h5>ajv</h5>
                            <h6>v8.12.0</h6>
                            <p>
                                DESCRIPTION<br />
                                Ajv JSON schema validator.
                            </p>
                            <p>
                                LICENSE<br />
                                MIT License<br />
                                <a href="https://licenses.nuget.org/MIT" target="_blank">https://licenses.nuget.org/MIT</a><br />
                            </p>
                            <hr style={{ borderWidth: '3px' }} />

                            <h5>babel-jest</h5>
                            <h6>v29.6.2</h6>
                            <p>
                                DESCRIPTION<br />
                                Jest plugin to use babel for transformation.
                            </p>
                            <p>
                                LICENSE<br />
                                MIT License<br />
                                <a href="https://licenses.nuget.org/MIT" target="_blank">https://licenses.nuget.org/MIT</a><br />
                            </p>
                            <hr style={{ borderWidth: '3px' }} />

                            <h5>bootstrap</h5>
                            <h6>v5.3.1</h6>
                            <p>
                                DESCRIPTION<br />
                                The front-end framework for developing responsive, mobile first projects on the web.
                            </p>
                            <p>
                                LICENSE<br />
                                MIT License<br />
                                <a href="https://licenses.nuget.org/MIT" target="_blank">https://licenses.nuget.org/MIT</a><br />
                            </p>
                            <hr style={{ borderWidth: '3px' }} />

                            <h5>cross-env</h5>
                            <h6>v7.0.3</h6>
                            <p>
                                DESCRIPTION<br />
                                NPM package that runs scripts that set and use environment variables across platforms.
                            </p>
                            <p>
                                LICENSE<br />
                                MIT License<br />
                                <a href="https://licenses.nuget.org/MIT" target="_blank">https://licenses.nuget.org/MIT</a><br />
                            </p>
                            <hr style={{ borderWidth: '3px' }} />

                            <h5>eslint-config-react-app</h5>
                            <h6>v7.0.1</h6>
                            <h5>eslint-plugin-flowtype</h5>
                            <h6>v8.0.3</h6>
                            <h5>eslint-plugin-import</h5>
                            <h6>v2.28.0</h6>
                            <h5>eslint-plugin-jsx-a11y</h5>
                            <h6>v6.7.1</h6>
                            <h5>eslint-plugin-react</h5>
                            <h6>v7.33.1</h6>
                            <h5>eslint</h5>
                            <h6>v8.47.0</h6>
                            <p>
                                DESCRIPTION<br />
                                ESLint is a tool for identifying and reporting on patterns found in ECMAScript/JavaScript code.
                            </p>
                            <p>
                                LICENSE<br />
                                MIT License<br />
                                <a href="https://licenses.nuget.org/MIT" target="_blank">https://licenses.nuget.org/MIT</a><br />
                            </p>
                            <hr style={{ borderWidth: '3px' }} />

                            <h5>history</h5>
                            <h6>v5.3.0</h6>
                            <p>
                                DESCRIPTION<br />
                                The history library that lets you easily manage session history anywhere JavaScript runs.
                            </p>
                            <p>
                                LICENSE<br />
                                MIT License<br />
                                <a href="https://licenses.nuget.org/MIT" target="_blank">https://licenses.nuget.org/MIT</a><br />
                            </p>
                            <hr style={{ borderWidth: '3px' }} />

                            <h5>http-proxy-middleware</h5>
                            <h6>v2.0.6</h6>
                            <p>
                                DESCRIPTION<br />
                                Node.js proxying.
                            </p>
                            <p>
                                LICENSE<br />
                                MIT License<br />
                                <a href="https://licenses.nuget.org/MIT" target="_blank">https://licenses.nuget.org/MIT</a><br />
                            </p>
                            <hr style={{ borderWidth: '3px' }} />

                            <h5>jest</h5>
                            <h6>v27.5.1</h6>
                            <p>
                                DESCRIPTION<br />
                                Jest is an open-source testing framework built on JavaScript, designed majorly to work with React and React Native-based web applications.
                            </p>
                            <p>
                                LICENSE<br />
                                MIT License<br />
                                <a href="https://licenses.nuget.org/MIT" target="_blank">https://licenses.nuget.org/MIT</a><br />
                            </p>
                            <hr style={{ borderWidth: '3px' }} />

                            <h5>merge</h5>
                            <h6>v2.1.1</h6>
                            <p>
                                DESCRIPTION<br />
                                NPM package for recursive merging of cloned objects.
                            </p>
                            <p>
                                LICENSE<br />
                                MIT License<br />
                                <a href="https://licenses.nuget.org/MIT" target="_blank">https://licenses.nuget.org/MIT</a><br />
                            </p>
                            <hr style={{ borderWidth: '3px' }} />

                            <h5>nan</h5>
                            <h6>v2.17.0</h6>
                            <p>
                                DESCRIPTION<br />
                                Native Abstractions for Node.js.
                            </p>
                            <p>
                                LICENSE<br />
                                MIT License<br />
                                <a href="https://licenses.nuget.org/MIT" target="_blank">https://licenses.nuget.org/MIT</a><br />
                            </p>
                            <hr style={{ borderWidth: '3px' }} />

                            <h5>oidc-client</h5>
                            <h6>v1.11.5</h6>
                            <p>
                                DESCRIPTION<br />
                                Library to provide OpenID Connect (OIDC) and OAuth2 protocol support for client-side, browser-based JavaScript client applications.
                            </p>
                            <p>
                                LICENSE<br />
                                MIT License<br />
                                <a href="https://licenses.nuget.org/MIT" target="_blank">https://licenses.nuget.org/MIT</a><br />
                            </p>
                            <hr style={{ borderWidth: '3px' }} />

                            <h5>rimraf</h5>
                            <h6>v3.0.2</h6>
                            <p>
                                DESCRIPTION<br />
                                Deep deletion  module for Node.js.
                            </p>
                            <p>
                                LICENSE<br />
                                MIT License<br />
                                <a href="https://licenses.nuget.org/MIT" target="_blank">https://licenses.nuget.org/MIT</a><br />
                            </p>
                            <hr style={{ borderWidth: '3px' }} />

                            <h5>typescript</h5>
                            <h6>v4.9.5</h6>
                            <p>
                                DESCRIPTION<br />
                                TypeScript is a language for application-scale JavaScript.
                            </p>
                            <p>
                                LICENSE<br />
                                MIT License<br />
                                <a href="https://licenses.nuget.org/MIT" target="_blank">https://licenses.nuget.org/MIT</a><br />
                            </p>
                            <hr style={{ borderWidth: '3px' }} />

                            <h5>web-vitals</h5>
                            <h6>v2.1.4</h6>
                            <p>
                                DESCRIPTION<br />
                                The web-vitals library is a tiny, modular library for measuring all the Web Vitals metrics on real users, in a way that accurately matches how they're measured by Chrome and reported to other Google tools.
                            </p>
                            <p>
                                LICENSE<br />
                                MIT License<br />
                                <a href="https://licenses.nuget.org/MIT" target="_blank">https://licenses.nuget.org/MIT</a><br />
                            </p>
                            <hr style={{ borderWidth: '3px' }} />

                            <h5>react-dom</h5>
                            <h6>v18.2.0</h6>
                            <h5>react-router-bootstrap</h5>
                            <h6>v0.26.2</h6>
                            <h5>react-router-dom</h5>
                            <h6>v6.15.0</h6>
                            <h5>react-scripts</h5>
                            <h6>v5.0.1</h6>
                            <h5>react-test-renderer</h5>
                            <h6>v18.2.0</h6>
                            <h5>react</h5>
                            <h6>v18.2.0</h6>
                            <h5>reactstrap</h5>
                            <h6>v9.2.0</h6>
                            <p>
                                DESCRIPTION<br />
                                ESLint is a tool for identifying and reporting on patterns found in ECMAScript/JavaScript code.
                            </p>
                            <p>
                                LICENSE<br />
                                MIT License<br />
                                <a href="https://licenses.nuget.org/MIT" target="_blank">https://licenses.nuget.org/MIT</a><br />
                            </p>
                            <hr style={{ borderWidth: '3px' }} />

                            <h5>workbox-background-sync</h5>
                            <h6>v6.6.0</h6>
                            <h5>workbox-broadcast-update</h5>
                            <h6>v6.6.0</h6>
                            <h5>workbox-cacheable-response</h5>
                            <h6>v6.6.0</h6>
                            <h5>workbox-core</h5>
                            <h6>v6.6.0</h6>
                            <h5>workbox-expiration</h5>
                            <h6>v6.6.0</h6>
                            <h5>workbox-google-analytics</h5>
                            <h6>v6.6.0</h6>
                            <h5>workbox-navigation-preload</h5>
                            <h6>v6.6.0</h6>
                            <h5>workbox-precaching</h5>
                            <h6>v6.6.0</h6>
                            <h5>workbox-range-requests</h5>
                            <h6>v6.6.0</h6>
                            <h5>workbox-routing</h5>
                            <h6>v6.6.0</h6>
                            <h5>workbox-strategies</h5>
                            <h6>v6.6.0</h6>
                            <h5>workbox-streams</h5>
                            <h6>v6.6.0</h6>
                            <p>
                                DESCRIPTION<br />
                                Workbox family, Production-ready service worker libraries and tooling.
                            </p>
                            <p>
                                LICENSE<br />
                                MIT License<br />
                                <a href="https://licenses.nuget.org/MIT" target="_blank">https://licenses.nuget.org/MIT</a><br />
                            </p>
                            <hr style={{ borderWidth: '3px' }} />
                         </div>
                    </div>
                </ModalBody>
                <ModalFooter />
            </Modal>
        </div>
    );
};